import { useEffect, useState } from "react";
import HeroSection from "@/components/sections/HeroSection";
import TrustBanner from "@/components/sections/TrustBanner";
import PriceSimulator from "@/components/sections/PriceSimulator";
import ServicesGrid from "@/components/sections/ServicesGrid";
import ZonesSection from "@/components/sections/ZonesSection";
import ReviewsCarousel from "@/components/sections/ReviewsCarousel";
import B2BSection from "@/components/sections/B2BSection";
import FAQSection from "@/components/sections/FAQSection";
import { api } from "@/lib/api";
import { useSEO } from "@/lib/hooks";

export default function HomePage() {
  const [services, setServices] = useState([]);
  useSEO({
    title: "Depann7 — Dépannage & Remorquage 24h/24 en Île-de-France",
    description: "Dépannage et remorquage 24h/24 et 7j/7 en Île-de-France. Intervention rapide pour panne, accident, batterie, crevaison ou transport de véhicule.",
  });
  useEffect(() => { api.get("/services").then((r) => setServices(r.data || [])).catch(() => {}); }, []);

  return (
    <>
      <HeroSection />
      <TrustBanner />

      <section id="request-form-anchor" className="bg-surface-50 py-14 sm:py-16 lg:py-20">
        <div className="max-w-2xl mx-auto px-4 lg:px-6">
          <div className="text-center mb-10">
            <h2 className="text-3xl lg:text-4xl font-extrabold text-txt-900">Estimez votre tarif en ligne</h2>
            <p className="text-txt-500 mt-2">Obtenez une estimation immédiate et transparente en quelques secondes</p>
          </div>
          <div className="bg-white rounded-2xl border border-surface-200 shadow-card overflow-hidden"><PriceSimulator /></div>
        </div>
      </section>

      <ServicesGrid services={services} />
      <ReviewsCarousel />
      <ZonesSection />
      <B2BSection />
      <FAQSection />
    </>
  );
}
